export const galleryPhotos = [
  {
    src: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/bbe7b153-80a8-4f2e-b123-96d41892dd05_compressed_DSC07362.webp",
    alt: "Efficiency cell meeting with industry experts",
    title: "Efficiency Cell Meeting",
    description:
      "An exclusive knowledge sharing session with industry experts driving efficiency and innovation.",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/62ae599d-64c6-4aa5-8ae3-3c5f5d9ce05d_compressed_DSC08821.webp",
    alt: "Textile Processing Cell PR learning and knowledge sharing session",
    title: "Textile Processing Cell",
    description:
      "Learning and knowledge sharing on textile processing with industry professionals.",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/3bab90b6-db9e-4196-a774-ce9a926c2886_compressed_TTH-8.webp",
    alt: "Textile Talent Hunt 8.0 Grand Finale champions receiving awards and prize money",
    title: "Textile Talent Hunt 8.0",
    description:
      "Grand Finale champions taking their awards and prize money from guests and jury board.",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/0d8eef37-753b-4a7c-b707-eb3c64cf5f8f_compressed_Textime-25.webp",
    alt: "TexTIME Episode 25 on Innovation in Denim with speakers and participants",
    title: "TexTIME Episode 25",
    description:
      'On the topic "Innovation in Denim" — a deep dive into the future of denim technology and trends.',
  },
  {
    src: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/502dda9a-8a92-4cbb-9efb-c67a88014c79_compressed_IMG_20250903_120502.webp",
    alt: "VIP delegation to China at Intertextile Shanghai Apparel Fabrics 2025",
    title: "Intertextile Shanghai 2025",
    description:
      "VIP delegation at Intertextile Shanghai Apparel Fabrics — exploring global textile innovation.",
  },
];